import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { clearInvoicesinStore, fetchInvoices, fetchInvoiceTotalDue } from '../store/domains/invoices/invoices.actions';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { FilterOutput } from '../shared/models/filters.model';
import isEmpty from 'lodash-es/isEmpty';
import { InvoiceTotalAmountDue } from '../models/invoice-model';

@Injectable({
    providedIn: 'root'
})
export class InvoicesService {
    private readonly store = inject(Store);
    private readonly consumerPortalApi = inject(ConsumerPortalApiService);

    getInvoices(customerId: number | string, startDate?: string, endDate?: string, search?: string, status?: string) {
        this.store.dispatch(fetchInvoices({ customerId, startDate, endDate, search, status }));
    }

    filter($e: FilterOutput, customerId: string, status?: string) {
        const startDate: string | undefined = !isEmpty($e.dates.startDate) ? $e.dates.startDate : undefined;
        const endDate: string | undefined = !isEmpty($e.dates.endDate) ? $e.dates.endDate : undefined;
        this.store.dispatch(clearInvoicesinStore());
        this.getInvoices(customerId, startDate, endDate, $e.search, status);
    }

    getInvoiceTotalAmountDue(customerId: number | string): Observable<InvoiceTotalAmountDue[]> {
        const url = `customer/${customerId}/invoices/total-due`;
        return this.consumerPortalApi.get(url);
    }

    getInvoiceTotalDue(customerId: number | string) {
        this.store.dispatch(fetchInvoiceTotalDue({ customerId }));
    }
}
